var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import Button from "@irati/ui/src/Button";
import Form from "@irati/ui/src/Form";
import FormattedMessage, { injectIntl } from "@irati/utils/lang";
import { Body, Label } from "@irati/ui/src/Typography";
import { createCompanyNewsRow } from "@irati/homepage/services/homepage";
import tracking from "@irati-tracking/homepage";
import getNewDefaultTiles from "../utils/getNewDefaultTiles";
import calculateHeightFromContent from "../utils/calculateHeightFromContent";
import { CancelButton, StyledCol, StyledRow, StyledSelecter, StyledSelectItem, StyledVerticalDiv } from "./styled";
import { ModalContent, StyledFooter } from "../../Modal/styled";
import { Modal } from "../../Modal";
import { RowNames } from "../../types";
var CompanyNewsModal = /** @class */ (function (_super) {
    __extends(CompanyNewsModal, _super);
    function CompanyNewsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { selected: RowNames.THREE_EQUAL };
        _this.updateSelectedRow = function (selected) {
            _this.setState({ selected: selected });
            tracking.homePageSelectRowSize(selected);
        };
        _this.onSubmit = function () {
            var selected = _this.state.selected;
            var _a = _this.props, onClose = _a.onClose, rowInt = _a.rowInt, auth = _a.auth;
            var newTiles = getNewDefaultTiles(selected, rowInt);
            var variables = {
                tenantId: auth.business.uuid,
                tiles: newTiles
            };
            _this.setState({ load: true });
            return createCompanyNewsRow(variables).then(function () {
                onClose();
                _this.setState({ load: false });
            });
        };
        return _this;
    }
    CompanyNewsModal.prototype.render = function () {
        var _this = this;
        var _a = this.state, load = _a.load, selected = _a.selected;
        var _b = this.props, formatMessage = _b.formatMessage, onClose = _b.onClose;
        var options = [
            { label: formatMessage({ id: "platform.homepage.companyNews.newRow.option" }, { value: "2" }), value: RowNames.TWO_EQUAL },
            { label: formatMessage({ id: "platform.homepage.companyNews.newRow.option" }, { value: "3" }), value: RowNames.THREE_EQUAL },
            { label: formatMessage({ id: "platform.homepage.companyNews.newRow.option" }, { value: "4" }), value: RowNames.FOUR_EQUAL }
        ];
        return (React.createElement(Modal, { onClose: onClose, header: React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.newRow.title" }) },
            React.createElement(Form, null,
                React.createElement(ModalContent, null,
                    React.createElement(Body, null,
                        React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.newRow.description" })),
                    React.createElement(StyledSelecter, null, options.map(function (option) {
                        var tiles = getNewDefaultTiles(option.value, 0);
                        return (React.createElement(StyledSelectItem, { key: option.value, selected: option.value === selected, onClick: function () {
                                if (!load) {
                                    _this.updateSelectedRow(option.value);
                                }
                            } },
                            React.createElement(StyledRow, null,
                                React.createElement(StyledVerticalDiv, null, tiles.map(function (tile) { return (React.createElement(StyledCol, { key: option.value + "-" + tile.ypos, height: Math.round(calculateHeightFromContent(tiles) / 10), xs: tile.config.columnWidth })); }))),
                            React.createElement(Label, { display: "block" }, option.label)));
                    }))),
                React.createElement(StyledFooter, null,
                    React.createElement(CancelButton, { tertiary: true, disabled: load, onClick: onClose },
                        React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.newRow.cancel" })),
                    React.createElement(Button, { disabled: load, onClick: this.onSubmit, primary: true, marginLeft: 2 },
                        React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.newRow.save" }))))));
    };
    return CompanyNewsModal;
}(Component));
export default injectIntl(withAuth(CompanyNewsModal));
